import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ToolSnapshotService } from 'src/app/component/tools/tool-snapshot/tool-snapshot.service';
import { Subscription } from 'rxjs';
import { ToolsService } from 'src/app/service/tools/tools.service';
import { ActivatedRoute } from '@angular/router';
import { ToolHistoryComponent } from '../tool-history/tool-history.component';
import { ToolTransferService } from '../tool-transfer/tool-transfer.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';

@Component({
  selector: 'app-tool-snapshot',
  templateUrl: '../tool-history/tool-history.component.html',
  styleUrls: ['../tool-history/tool-history.component.scss'],
})
export class ToolSnapshotComponent extends ToolHistoryComponent implements OnInit, OnDestroy {
  @Input() row: any;

  subscription: Subscription;

  constructor(
    private activatedRate: ActivatedRoute,
    private toolSnapshotService: ToolSnapshotService,
    protected loaderService: LoaderService,
    public toolsService: ToolsService,
    public toolTransferService: ToolTransferService,
    momentService: MomentService
  ) {
    super(activatedRate, toolsService, toolTransferService, loaderService, momentService);
  }

  ngOnInit(): void {
    this.subscription = this.toolSnapshotService.currentSnapshots.subscribe(
      data =>
      (this.snapshot = data.find(({ row }) => {
        return this.row.id === row.id;
      })),
    );
    this.subscription = this.toolSnapshotService.currentSnapshotsDates.subscribe(
      data =>
      (this.snapshotDates = data.find(({ id }) => {
        return this.row.id === id;
      })),
    );

    this.id = this.row.id;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  fetch(id: number, params: any = {}) {
    this.toolsService.history.tools(id, params).subscribe(
      res => {
        const { data, pagination } = res;
        this.toolsService.readById.tools(id, { cache: 'clear', embed: 'model,vehicleDetail' }).subscribe(res => {
          const { data: tool } = res;
          this.toolSnapshotService.replaceSnapshot({
            row: this.row,
            data,
            pagination,
            tool,
          });
        });
      },
      err => {
        console.error(err);
      },
    );
  }

  fetchNext(nextPage: number, event: any) {
    event.preventDefault();
    this.params = { ...this.params, page: nextPage };
    this.toolsService.history.tools(this.row.id, this.params).subscribe(res => {
      const { data, pagination } = res;
      this.toolSnapshotService.mergeSnapshotData({
        row: this.row,
        data,
        pagination,
      });
    });
  }
}
